import type { z } from "zod/v4";
import type { WrappedMutatorDefinition } from "@corpuscomplete/zero-data-transformer";
import type { Transaction } from "@rocicorp/zero";
import type { Context } from "./schema";
import { zeroDataTransformer } from "./transformer";

type SchemaWrappedMutatorDefinition<TSchema extends z.ZodType<any, any>> = WrappedMutatorDefinition<
  TSchema["_zod"]["input"],
  TSchema["_zod"]["output"],
  Context,
  any
> & {
  schema: TSchema;
};

export function withZeroTransaction<Schema extends z.ZodType<any, any>>(
  schema: Schema,
  func: (opts: { tx: Transaction; ctx: Context; args: z.infer<Schema> }) => Promise<void>,
): SchemaWrappedMutatorDefinition<Schema> {
  return Object.assign(zeroDataTransformer.defineMutator(schema, func), {
    schema,
  }) as SchemaWrappedMutatorDefinition<Schema>;
}
